import './App.css';
import OrderBook from './components/OrderBook';

function App() {
  return (
    <div className='m-2'>
      <OrderBook/>
    </div>
  );
}

export default App;
